// ChartOptions.ts
import { ChartOptions, CrosshairMode, DeepPartial } from "lightweight-charts";
import moment from "moment-timezone";

interface CustomChartOptions {
  chartWidth: number;
  viewportSize: any;
  isFetching: boolean;
  intervalValue: string;
}

const getTimezoneLocale = (timezone: string) => {
  if (timezone.includes("Australia")) {
    return "en-AU";
  } else if (timezone.includes("America")) {
    return "en-US";
  } else if (timezone.includes("Europe")) {
    return "en-GB";
  } else if (timezone.includes("Asia")) {
    if (timezone.includes("Tokyo")) {
      return "ja-JP";
    } else if (timezone.includes("Shanghai")) {
      return "zh-CN";
    }
  }
  return undefined;
};
// in case if we need to specify locale value to chart option
const userTimezone = moment.tz.guess();

const userLocale = getTimezoneLocale(userTimezone) ?? "America";

// chart options for the lightweight charts
export const getChartOptions = ({
  chartWidth,
  viewportSize,
  isFetching,
  intervalValue,
}: CustomChartOptions): DeepPartial<ChartOptions> => ({
  height: 600,
  width: viewportSize < 400 ? 700 : chartWidth,
  watermark: { text: "Caleb and Brown" },
  autoSize: true,
  localization: {
    dateFormat: "yyyy-MM-dd",
    locale: userLocale,
  },
  crosshair: {
    mode: CrosshairMode.Normal,
  },
  timeScale: {
    timeVisible: intervalValue === "1D" || intervalValue === "1W" ? true : false,
  },
  rightPriceScale: {
    alignLabels: true,
    scaleMargins: {
      bottom: 0.3,
    },
  },
  handleScroll: isFetching
    ? {
        mouseWheel: false,
        pressedMouseMove: false,
        horzTouchDrag: false,
        vertTouchDrag: false,
      }
    : { mouseWheel: true, pressedMouseMove: true, horzTouchDrag: true, vertTouchDrag: true },
  handleScale: isFetching
    ? {
        axisPressedMouseMove: false,
        mouseWheel: false,
        pinch: false,
      }
    : { axisPressedMouseMove: true, mouseWheel: true, pinch: true },
});
